import { useSelector } from 'react-redux';
import selectors from 'selectors/selectors.js';
import inboxFoldersSelector from 'screens/inbox/store/inboxFoldersSelector.js';
import getFolderEventsById from 'lib/getFolderEventsById.js';
import CombinedMessages from 'screens/inbox/inboxSidebar/CombinedMessages.js';
import setQuery from 'lib/setQuery.js';
import { action } from 'lib/actionHelpers.js';
import React, { useEffect } from 'react';
import Slider from 'components/Slider.js';
import ScreenHeader from 'components/ScreenHeader.js';
import NotificationSliderTodos from 'components/notificationSlider/NotificationSliderTodos.js';
import { useLocation } from 'react-router';
import { useScrollPagination } from 'hooks/index.js';
import { publishAction } from 'redux/actions/messagesActions';

const getTabs = ({ messageCounts, folders, folderEvents, todoCountDueToday, todoCountOverdue, todoEventsDueTodayCount, userId }) => [
  //
  ...folders.map((folder) => ({
    id: folder.id,
    label: null,
    svg: folder.svg,
    onClick: () => {
      const viewingRecordData = {
        event: 'viewing_record',
        key: `viewing_record`,
        message: { id: null, userId: userId, initials: '', clear: true },
      };
      publishAction({ data: viewingRecordData });
    },
    count: messageCounts[folder.id],
    dataTitle: folder.name,
    eventCount: getFolderEventsById(folderEvents, folder.id).length || undefined,
  })),
  { id: 'todos', label: null, svg: 'Todos', count: isNaN(todoCountDueToday) ? '0' : todoCountDueToday, dataTitle: 'Todos due today', eventCount: todoEventsDueTodayCount },
  { id: 'todosOverdue', label: null, svg: 'TodoSchedule', count: isNaN(todoCountOverdue) ? '0' : todoCountOverdue, dataTitle: 'Overdue todos' },
];

const NotificationSliderContent = ({ onTabClick }) => {
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const notificationFolderId = useSelector(selectors.notificationFolderId);
  const notificationSliderOpen = useSelector(selectors.notificationSliderOpen);
  const notificationSidebarTodosDueToday = useSelector(selectors.notificationSidebarTodosDueToday);
  const notificationSidebarOverdueTodos = useSelector(selectors.notificationSidebarOverdueTodos);
  const todoCountDueToday = (notificationSidebarTodosDueToday.length > 99 ? 99 : notificationSidebarTodosDueToday.length) || 0;
  const todoCountOverdue = (notificationSidebarOverdueTodos.length > 99 ? 99 : notificationSidebarOverdueTodos.length) || 0;
  const messageCounts = useSelector(selectors.messageCounts) || {};
  const folderEvents = useSelector(selectors.folderEvents);
  const folders = useSelector(inboxFoldersSelector);
  const todoEvents = useSelector(selectors.todoEvents);
  const todoEventsDueToday = useSelector(selectors.todoEventsDueToday);
  const embedded = useSelector(selectors.embeddedNotificationSlider);
  const todoEventsDueTodayCount = (todoEventsDueToday.length > 99 ? `99` : todoEventsDueToday.length) || undefined;
  const messages = useSelector(selectors.inboxCombinedMessages(notificationFolderId));
  const user = useSelector((state) => state.user);
  const userId = (user || {}).id;
  const visibleFolders = folders.filter((n) => (n.visibility || []).includes('notificationsSlider'));
  const folderEventMap = Object.fromEntries(visibleFolders.map((n) => [n.id, getFolderEventsById(folderEvents, n.id)]));
  const folderComponents = Object.fromEntries(visibleFolders.map((n) => [n.id, <CombinedMessages folderId={n.id} />]));
  const eventMap = {
    ...folderEventMap,
    todosOverdue: todoEvents,
    todos: todoEvents,
  };

  const handleHide = () => setQuery({ notificationFolderId: null });

  const handleTabClick = (e, tab) => {
    onTabClick(e, tab);
    const type = tab === 'todos' ? 'updated_todo' : 'new_message';
    const ids = (eventMap[tab] || [])
      .map((n) => {
        const eventData = n.todo ? n.todo.event_data : n.event_data;
        return (eventData || {}).id;
      })
      .filter((n) => !!n);
    if (ids.length > 0) {
      action('ACKNOWLEDGE_EVENT_TYPE', {
        type,
        ids,
        serviceProviderId,
      });
    }
  };

  const [handleScrollPagination] = useScrollPagination(() => {
    const messageCount = messageCounts[notificationFolderId] || 0;
    if (messageCount && messages.length < messageCount) {
      action('INBOX_INCREMENT_OFFSET', { folderId: notificationFolderId, amount: 100 });
    }
  });

  return (
    <Slider className={`notification-slider ${embedded ? 'embedded' : ''}`} show={!!notificationSliderOpen} reversed={true} onHide={handleHide}>
      <ScreenHeader tabs={getTabs({ todoCountDueToday, todoCountOverdue, folders: visibleFolders, messageCounts, todoEventsDueTodayCount, folderEvents, userId })} filters={[]} param={'notificationFolderId'} onTabClick={handleTabClick} />
      <div className={'notification-content scrollbar-dark'} onScroll={handleScrollPagination}>
        {
          {
            undefined: null,
            ...folderComponents,
            todosOverdue: <NotificationSliderTodos />,
            todos: <NotificationSliderTodos />,
          }[notificationFolderId]
        }
      </div>
    </Slider>
  );
};

export default NotificationSliderContent;
